<!--==============================
=            EXCHANGE            =
===============================-->
<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Exchange</div>
      </base-header>
    </v-row>
    <v-row>

      <v-col cols="12" md="3" sm="12" v-for="item in exchanges" :key="item.id">
        <base-card>
          <div slot="card-header">
            <v-list-item dark three-line>
              <v-list-item-content >
                <div class="text-subtitle-1">
                  {{item.coin}}
                </div>
                <v-list-item-title class="subtitle-1 font-weight-black ">
                  ${{item.price}}
                </v-list-item-title>
                <v-list-item-subtitle class="mb-2 mt-1">
                  <v-chip :color="item.color" class="white--text" label>
                    <v-icon left>
                      {{item.icon}}
                    </v-icon>
                    {{item.updown}}%
                  </v-chip>

                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-avatar tile class="rounded-lg text-lef tpl-1 card-light" size="60"> <img
                     :src="require(`../../assets/images/coin/${item.img}.png`)">
              </v-list-item-avatar>
            </v-list-item>
          </div>
     
        </base-card>


      </v-col>



    </v-row>


  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    data() {
      return {
        exchanges: [{
          id: '1',
          coin: 'BTCUSDT',
          img: 'btc',
          color: 'red',
          price: '42.954',
          icon: 'south',
          updown: '-0,89'
        }, {
          id: '11',
          coin: 'ADAUSDT',
          img: 'ada',
          color: 'red',
          price: '3.954',
          icon: 'south',
          updown: '-0,19'
        }, {
          id: '12',
          coin: 'BNBUSDT',
          img: 'bnb',
          color: 'green',
          price: '454',
          icon: 'north',
          updown: '+8,89'
        }, {
          id: '13',
          coin: 'BATUSDT',
          img: 'bat',
          color: 'red',
          price: '0,00954',
          icon: 'south',
          updown: '-0,89'
        },{
          id: '14',
          coin: 'ZILUSDT',
          img: 'zil',
          color: 'green',
          price: '42.954',
          icon: 'north',
          updown: '-0,89'
        }, {
          id: '15',
          coin: 'LTCUSDT',
          img: 'ltc',
          color: 'green',
          price: '3.954',
          icon: 'north',
          updown: '-0,19'
        }, {
          id: '16',
          coin: 'DOGEUSDT',
          img: 'doge',
          color: 'green',
          price: '454',
          icon: 'north',
          updown: '+8,89'
        }, {
          id: '17',
          coin: 'AVAUSDT',
          img: 'avalanche',
          color: 'green',
          price: '0,00954',
          icon: 'north',
          updown: '-0,89'
        },{
          id: '18',
          coin: 'BTCUSDT',
          img: 'btc',
          color: 'red',
          price: '42.954',
          icon: 'north',
          updown: '-0,89'
        }, {
          id: '19',
          coin: 'XVSUSDT',
          img: 'xvs',
          color: 'red',
          price: '3.954',
          icon: 'south',
          updown: '-0,19'
        }, {
          id: '21',
          coin: 'MANAUSDT',
          img: 'mana',
          color: 'red',
          price: '454',
          icon: 'south',
          updown: '+8,89'
        }, {
          id: '22',
          coin: 'SOLUSDT',
          img: 'solana',
          color: 'red',
          price: '0,00954',
          icon: 'south',
          updown: '-0,89'
        },{
          id: '218',
          coin: 'BNBUSDT',
          img: 'bnb',
          color: 'red',
          price: '42.954',
          icon: 'north',
          updown: '-0,89'
        }, {
          id: '129',
          coin: 'ADASDT',
          img: 'ada',
          color: 'red',
          price: '3.954',
          icon: 'south',
          updown: '-0,19'
        }, {
          id: '221',
          coin: 'RAMP',
          img: 'ramp',
          color: 'red',
          price: '454',
          icon: 'south',
          updown: '+8,89'
        }, {
          id: '222',
          coin: 'CAKE',
          img: 'cake',
          color: 'green',
          price: '0,00954',
     icon: 'north',
          updown: '+0,89'
        }]
      }
    },

  }
</script>

<style>
  .card-light {
    border-radius: 1em;
    border: 1px solid rgba(255, 255, 255, 0.5);
    text-shadow: 0 0 1em rgba(0, 0, 0, 0.5);
    background: rgba(255, 255, 255, 0.2);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    transform: perspective(500px);
    transform-style: preserve-3d;
  }
</style>


<!--====  End of EXCHANGE  ====-->